import App from "./App.vue";
import router from "./router";
import plugins from "./plugins";
import Toast from "./plugins/toastification";
import axios from "./plugins/axios";
import VuePhoneNumberInput from "vue-phone-number-input";
import VueGoogleMaps from "@fawmi/vue-google-maps";
import VueQRCodeComponent from "vue-qr-generator";
import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import clickOutside from "./directives/clickOutside";
import { useAuthStore } from "./stores/auth";
import { useUserStore } from "./stores/user";
import { useOrganisationStore } from "./stores/organisation";
import DropZone from "dropzone-vue";
import "dropzone-vue/dist/dropzone-vue.common.css";
import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import Vue3Tour from "vue3-tour";

import "vue3-tour/dist/vue3-tour.css";

// style
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import "vue-tel-input/dist/vue-tel-input.css";
import "vue-toastification/dist/index.css";
import "@/assets/scss/app.scss";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import "maz-ui/styles"; // or import 'maz-ui/css/main.css'
import "@/assets/css/app.css";
import "@/assets/css/mobile.css";
import "@/assets/css/fontawesome/css/fontawesome.css";
import "@/assets/css/fontawesome/css/solid.css";
import "@mdi/font/css/materialdesignicons.css"; // Ensure you are using css-loader

// Vuetify
import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import VueMultiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

import tooltipDirective from "./directives/tooltip";

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    themes: {
      light: {
        primary: "#00a0c1",
        accent: "#8c9eff",
      },
    },
  },
});
const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

export const app = createApp(App);
// Prevents toasts of the same type from appearing simultaneously, discarding duplicates
const filterBeforeCreate = (toast, toasts) => {
  if (toasts.filter((t) => t.type === toast.type).length !== 0) {
    // Returning false discards the toast
    return false;
  }
  // You can modify the toast if you want
  return toast;
};
app.use(Vue3Tour);

app.use(pinia);
app.use(axios);
app.use(router);
app.use(plugins);
app.use(Toast, { filterBeforeCreate });
app.use(vuetify);
app.use(DropZone);
app.component("vue-phone-number-input", VuePhoneNumberInput);
app.component("qr-code", VueQRCodeComponent);
app.component("VueDatePicker", VueDatePicker);

app.component("VueMultiselect", VueMultiselect);
app.directive("click-outside", clickOutside);
app.directive("tooltip", tooltipDirective);
// Now register the auth store globally
app.config.globalProperties.$authStore = useAuthStore();
app.config.globalProperties.$userStore = useUserStore();
app.config.globalProperties.$organisationStore = useOrganisationStore();

app.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAwOeHZuzwrQTuWL3eyCh4NK9htFkCzs-c",
    libraries: "places",
  },
});

app.mount("#app");
